import { createAction } from '@reduxjs/toolkit';

import { EditSpotPayload, SetStrictExternalUrlsFlagPayload } from './spotsTypes';

export const fetchInitSpotData = createAction<string>('spots/fetchInitSpotData');

export const editSpot = createAction<EditSpotPayload>('spots/editSpot');

export const fetchAuthorizedDomains = createAction('spots/fetchAuthorizedDomains');

export const addAuthorizedDomain = createAction<string>('spots/addAuthorizedDomain');

export const removeAuthorizedDomain = createAction<string>('spots/removeAuthorizedDomain');

export const fetchSpotModerationData = createAction<string>('spots/fetchSpotModerationData');

export const fetchSpotPolicyData = createAction<string>('spots/fetchSpotPolicyData');

export const setStrictExternalUrlsFlag = createAction<SetStrictExternalUrlsFlagPayload>(
  'spots/setStrictExternalUrlsFlag'
);
